import type {ReactElement} from 'react';
import React from 'react';
import {Modal} from '@Components/modal';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import type {SocialPostsDialogPanelProps} from '@Panels/social-posts-dialog-panel';
import {useAppSelector} from '@/hooks';

const PANEL_ID = 'social-posts-dialog-panel';
export type SocialPostsDialogModalProps = SocialPostsDialogPanelProps;

export default function SocialPostsDialogModal(): ReactElement<any> {
  const modalData = useAppSelector((state) => {
    return state.modals.modalsHashmap[MODALS_IDS.SOCIAL_POSTS_DIALOG_MODAL];
  });

  const height = '564px';
  const width = '827px';

  return (
    <Modal modalId={MODALS_IDS.SOCIAL_POSTS_DIALOG_MODAL} modalHeight={height} panelId={PANEL_ID} modalWidth={width}>
      <LazyPanel
        panelDirectoryName="social-posts-dialog-panel"
        panelProps={{
          ...modalData.panelProps,
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openSocialPostsDialogModal = (props: SocialPostsDialogModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.SOCIAL_POSTS_DIALOG_MODAL,
      panelProps: props,
    })
  );
};
